import React from 'react';
import './TariffModal.css';

const TariffModal = ({ isOpen, onClose, formData, onChange, onSubmit, isEditing, loading }) => {
  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    onChange({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>{isEditing ? 'Editar Tarifa' : 'Nueva Tarifa'}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nombre *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Descripcion</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              rows={3}
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Analisis incluidos *</label>
              <input
                type="number"
                name="max_query_limit"
                value={formData.max_query_limit}
                onChange={handleInputChange}
                min={0}
                required
              />
              <span className="form-help">0 = Ilimitado</span>
            </div>

            <div className="form-group">
              <label>Coste extra por analisis</label>
              <input
                type="number"
                name="extra_query_cost"
                value={formData.extra_query_cost}
                onChange={handleInputChange}
                min={0}
                step={0.01}
              />
            </div>
          </div>

          <div className="form-group">
            <label>Orden</label>
            <input
              type="number"
              name="sort_order"
              value={formData.sort_order}
              onChange={handleInputChange}
              min={0}
            />
          </div>

          <div className="form-group checkbox-group">
            <label>
              <input
                type="checkbox"
                name="enabled"
                checked={formData.enabled}
                onChange={handleInputChange}
              />
              Habilitada
            </label>
          </div>

          <div className="modal-actions">
            <button type="button" onClick={onClose} className="btn-secondary">
              Cancelar
            </button>
            <button type="submit" disabled={loading} className="btn-primary">
              {loading ? 'Guardando...' : isEditing ? 'Actualizar' : 'Crear'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TariffModal;
